module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('div', {
    staticClass: "title-part"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781250024572_toc01#toctitle2",
      "id": "title2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PART ONE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "e9781250024572_i0002.jpg",
      "src": "e9781250024572_i0002.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "verse"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("“It is remarkable,” he said. “A man cannot make general"), _c('br'), _vm._v(" observations to any extent, on any subject, without betraying"), _c('br'), _vm._v(" himself, without introducing his entire individuality,"), _c('br'), _vm._v(" and presenting, as in an allegory, the fundamental"), _c('br'), _vm._v(" theme and problem of his own existence. This,"), _c('br'), _vm._v(" Engineer, is what you have just done.”")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "source"
  }, [_c('span', [_vm._v("—SETTEMBRINI TO HANS CASTORP"), _c('br'), _vm._v(" THOMAS MANN, "), _c('em', {
    staticClass: "i"
  }, [_vm._v("THE MAGIC MOUNTAIN")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227c32f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781250024572_p01.vue
// module id = 75
// module chunks = 0